import { Gallery } from '../services/UploadManagementServiceTypes';

export const getGalleryEditorUrl = (gallery: Gallery) =>
  `${window.location.origin}/account#!/panoramaGallery/editor/${gallery.guid}`;
